module.exports = __webpack_public_path__ + "media/images/check_mark-ba84b27e5992eec455ba80daf0dade31.png";